module.exports = __webpack_public_path__ + "img/Event.cc134925.svg";